if (!customElements.get('featured-collection-grid')) {
  customElements.define(
    'featured-collection-grid',
    class FeaturedCollectionGrid extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-featured-collection-product-grid]');
        this.buttons = Array.from(this.querySelectorAll('[data-featured-collection-columns]'));
        this.scrollButtons = Array.from(this.querySelectorAll('[data-featured-collection-scroll]'));

        if (!this.grid || this.buttons.length === 0) return;

        this.storageKey = `builtbymission.featuredCollectionColumns.${this.dataset.sectionId}`;
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.setColumns(button.dataset.featuredCollectionColumns, true));
        });
        this.scrollButtons.forEach((button) => {
          button.addEventListener('click', () => this.scrollProducts(button.dataset.featuredCollectionScroll));
        });
        this.grid.addEventListener('scroll', () => this.updateScrollButtons(), { passive: true });

        let initialColumns = this.dataset.defaultMobileColumns || '2';
        if (!window.Shopify?.designMode) {
          try {
            initialColumns = sessionStorage.getItem(this.storageKey) || initialColumns;
          } catch (error) {
            // The selector remains usable when browser storage is unavailable.
          }
        }

        this.setColumns(initialColumns, false);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            this.updateScrollHeight();
            this.updateScrollButtons();
          });
          const firstProduct = this.grid.querySelector('.grid__item');
          if (firstProduct) this.resizeObserver.observe(firstProduct);
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      setColumns(columns, persist) {
        const selectedColumns = columns === '1' ? '1' : '2';
        this.dataset.mobileColumns = selectedColumns;

        this.buttons.forEach((button) => {
          const isActive = button.dataset.featuredCollectionColumns === selectedColumns;
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        this.grid.scrollTop = 0;

        if (persist) {
          try {
            sessionStorage.setItem(this.storageKey, selectedColumns);
          } catch (error) {
            // The selector remains usable when browser storage is unavailable.
          }
        }

        requestAnimationFrame(() => this.updateScrollHeight());
      }

      scrollProducts(direction) {
        this.grid.scrollBy({
          top: (direction === 'up' ? -1 : 1) * this.grid.clientHeight,
          behavior: 'smooth',
        });
      }

      updateScrollHeight() {
        const usesInternalScroll =
          window.matchMedia('(max-width: 749px)').matches &&
          this.dataset.mobileColumns === '1' &&
          this.dataset.oneColumnMode === 'scroll';

        if (!usesInternalScroll) {
          this.style.removeProperty('--featured-collection-scroll-height');
          this.updateScrollButtons();
          return;
        }

        const firstProduct = this.grid.querySelector('.grid__item');
        if (!firstProduct) return;

        const productHeight = Math.ceil(firstProduct.getBoundingClientRect().height);
        if (productHeight > 0) {
          this.style.setProperty('--featured-collection-scroll-height', `${productHeight}px`);
        }

        requestAnimationFrame(() => this.updateScrollButtons());
      }

      updateScrollButtons() {
        if (this.scrollButtons.length === 0) return;

        const usesInternalScroll =
          window.matchMedia('(max-width: 749px)').matches &&
          this.dataset.mobileColumns === '1' &&
          this.dataset.oneColumnMode === 'scroll';
        const maximumScroll = this.grid.scrollHeight - this.grid.clientHeight;
        const canScroll = usesInternalScroll && maximumScroll > 1;

        this.scrollButtons.forEach((button) => {
          const isUp = button.dataset.featuredCollectionScroll === 'up';
          button.hidden = !canScroll || (isUp ? this.grid.scrollTop <= 1 : this.grid.scrollTop >= maximumScroll - 1);
        });
      }
    }
  );
}
